import Button from '../../../components/base/Button';

export default function TrialSection() {
  return (
    <section className="relative py-20 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/1a60e527c4c719dbdc0cc26009044dde.jpg"
          alt="Trial Service"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-orange-500/90 to-red-500/90"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center text-white">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Try Our Service for 24 hours!
            </h2>
            <p className="text-lg text-white/90 leading-relaxed">
              Experience the unparalleled performance of our digital media support service with complete access to all setup and configuration features. Try it out and fully optimize your entertainment system. Begin your trial today!
            </p>
          </div>
          <div className="text-center lg:text-right">
            <Button variant="secondary" size="lg" className="bg-white text-orange-500 hover:bg-gray-100">
              Get Trial
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
